import moment from "moment";

export function getBinaryMarketDisplayName(input_data) {
    let returnValue = []
    const splitedValue = !!input_data ? input_data.split(' ') : [];
    returnValue[0] = "";
    returnValue[1] = "";
    if(splitedValue.length>0){
        if(splitedValue.length - 8 === 0){
            returnValue[0] += splitedValue[0]
        }else{
            for (let i=0;i < splitedValue.length - 7;i++){
                returnValue[0] += splitedValue[i] + (i < splitedValue.length - 8 ? " " : "");
            }
        }
        returnValue[1] += `${getLocalTimeStr(splitedValue[splitedValue.length - 5], splitedValue[splitedValue.length - 4])} - ${getLocalTimeStr(splitedValue[splitedValue.length - 2], splitedValue[splitedValue.length - 1])}`
    }

    return returnValue
}

export function getLocalTimeStr(hr,min) {
    const totalGMTMins = parseInt(hr) * 60 + parseInt(min);
    let totalLocalMins = totalGMTMins + (-1 * new Date().getTimezoneOffset())
    if (totalLocalMins > 1440){
        totalLocalMins = totalLocalMins - 1440
    }
    const hh = parseInt(totalLocalMins/60).toString()
    const mm = (totalLocalMins%60).toString()
    return `${hh.length === 1 ? '0':''}${hh}:${mm.length === 1 ? '0':''}${mm}`
}

export function getBinaryCompetitionDisplayName(input_data) {
    return (input_data.substr(0 ,input_data.lastIndexOf(' ')))
}

export function getBinaryDescriptionDisplay(input_data) {
    let returnValue = [];
    const firstSplit=input_data.split('/');
    returnValue[0] = getBinaryCompetitionDisplayName(firstSplit[0]) + '/' + firstSplit[1];
    returnValue[1] = getBinaryMarketDisplayName(firstSplit[2]); 
    returnValue[2] = firstSplit[3];
    // SILVER SPOT 10/SILVER SPOT 09-03-22/SILVER SPOT 09-03-22 DAILY 04 00 to 18 00/25.9
    return returnValue
}


export function scoreFormatDate(date) {
    if (!date) {
        return ""
    }
    date = new Date(date)
    let month = [];
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sept";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";
    let mn = date.getMonth() + 1;
    mn = mn > 9 ? mn : "0" + mn
    let dt = date.getDate();
    dt = dt > 9 ? dt : "0" + dt
    let hr = date.getHours();
    hr = hr > 9 ? hr : "0" + hr
    let min = date.getMinutes();
    min = min > 9 ? min : "0" + min
    let year = date.getFullYear()
    let formatedDate = dt + "/" + mn + "/" + year + " " + hr + ":" + min
    return formatedDate
}